import { render, staticRenderFns } from "./CompanySync.vue?vue&type=template&id=1323d07a&scoped=true"
import script from "./CompanySync.vue?vue&type=script&lang=js"
export * from "./CompanySync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323d07a",
  null
  
)

export default component.exports